module.exports = {
	"header": "Vogue Scandinavia launches next-gen Content Commerce tech by Spotin",
	"date": "2022/04/07",
	"imgSrc": "18.jpg",
	"imgAlt": "Vogue Scandinavia launches next-gen Content Commerce tech by Spotin",
	"ingress": "By: What's New in Publishing (in English)",
	"externalLink": "https://whatsnewinpublishing.com/vogue-scandinavia-launches-next-gen-content-commerce-tech-by-spotin/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/18/article.json
// module id = 87
// module chunks = 0